import {pickKeysFromSearchParams} from '@hconnect/common/query-params'
import {DateRange, ShiftQuickSelectSlots} from '@hconnect/common/types'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {urlToFilterSettings, FilterOptions} from '@widgets/shift-event-filters'
import {useMemo} from 'react'
import {SetURLSearchParams, useSearchParams} from 'react-router'
import {useLocalStorage} from 'react-use'

import {EVENT_FILTERS} from './useEventsFilter'

const KEY_TIME_RANGE = 'timeRange'
const KEYS = [KEY_TIME_RANGE]

const getTimeRange = (
  filters: string,
  timezone: string
): DateRange | ShiftQuickSelectSlots | undefined => {
  const filterOptions: FilterOptions = urlToFilterSettings(new URLSearchParams(filters), timezone)
  return filterOptions[KEY_TIME_RANGE]
}

export const useTimeRange = (plantId: string): DateRange | ShiftQuickSelectSlots | undefined => {
  const timezone = useUpmPlantTimezone(plantId)
  const [storageData] = useLocalStorage<string>(EVENT_FILTERS)
  const [params]: [URLSearchParams, SetURLSearchParams] = useSearchParams()

  return useMemo<DateRange | ShiftQuickSelectSlots>(() => {
    const timeRangeQueryParam: string =
      pickKeysFromSearchParams(params, KEYS).toString() || storageData || ''
    return getTimeRange(timeRangeQueryParam, timezone) || 'currentShift'
  }, [params, storageData, timezone])
}
